var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9938 4.9566V4.91496C23.9824 4.88601 23.9685 4.85817 23.9522 4.83169L23.921 4.79005L23.8585 4.72238L23.8221 4.69115L23.7544 4.65992H23.7284L12.4233 0.0379633C12.2981 -0.0126544 12.1581 -0.0126544 12.0329 0.0379633L0.753923 4.58185H0.727898L0.660235 4.61308L0.6238 4.64431L0.561341 4.71197L0.530113 4.75361C0.513782 4.78009 0.49986 4.80794 0.488474 4.83689V4.87853C0.483009 4.92173 0.483009 4.96545 0.488474 5.00865C0.488474 9.56098 0.488474 13.2897 0.488474 18.099C0.489515 18.3091 0.616839 18.498 0.811177 18.5779L12.0329 23.2623C12.0893 23.2847 12.1493 23.2969 12.2099 23.2987C12.2705 23.2969 12.3305 23.2847 12.3869 23.2623L23.6711 18.5779C23.8655 18.498 23.9928 18.3091 23.9938 18.099V5.08673C23.9993 5.04353 23.9993 4.9998 23.9938 4.9566ZM12.2255 1.09456L16.504 2.80698L6.77081 6.92406L2.32061 5.07111L12.2255 1.09456ZM11.6894 22.0079L1.467 17.7503C1.467 13.7026 1.467 9.96878 1.467 5.84664L5.44356 7.49139L11.6894 10.0939V22.0079ZM12.2307 9.21422L8.11885 7.49139L17.8624 3.3587L22.1253 5.07632L15.9158 7.67877L12.2307 9.21422ZM12.746 22.0079V10.0939L15.6764 8.8759L22.9633 5.83623L22.9893 17.7503L12.746 22.0079Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.99201eec9cf53890876c1be9d87e4292.svg";
export { ForwardRef as ReactComponent };